/* function to check which sidebar item is active,
takes in prop containing a string (e.g buying, reorder, hub)
and checks if it is found in the current pathname
*/

import { HUB_PATH_APP } from '../routes';

export const getIsActive = ({
  href,
  path,
  currentPathname,
}: {
  href?: string;
  path?: string;
  currentPathname?: string;
}) => {
  if (!href || !path || !currentPathname) return false;

  // Handle hub special cases
  if (path.includes('hub')) {
    // Keep hub icon active on budget page
    if (
      path === HUB_PATH_APP.root &&
      currentPathname.includes('/hub/budgets')
    ) {
      return true;
    }
    // Non-budget hub paths use exact matching
    return currentPathname.startsWith(path);
  }

  // Handle insights with exact matching
  if (path.includes('insights')) {
    return currentPathname.startsWith(path);
  }

  // Default: truncate to first segment
  const truncatedPath = path.split('/').slice(0, 2).join('/');
  return currentPathname.startsWith(truncatedPath);
};
